// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"22ebd1dc","418":"73f93e83"}[chunkId] + ".chunk.js";
};